import { Link } from 'react-router';

import { canUse } from '../permissions.js';
import type { AdminSelf } from '@saay/api-client';

/** Opens the audit log filtered to one resource (ADM-29). */
export function auditTrailPath(resourceType: string, resourceId: string): string {
  const params = new URLSearchParams({ resourceId, resourceType });
  return `/audit?${params.toString()}`;
}

export function AuditTrailLink({
  resourceId,
  resourceType,
  self,
}: {
  readonly resourceId: string;
  readonly resourceType: string;
  readonly self: AdminSelf;
}) {
  if (!canUse(self, 'listAdminAuditEvents')) {
    return null;
  }
  return <Link to={auditTrailPath(resourceType, resourceId)}>سوابق</Link>;
}
